// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__BZHth","savePackageButton":"ClientWallet_savePackageButton__1tNbf"};